var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_vm._l((_vm.navigation),function(navigationItem,index){return _c(_vm.getComponent(navigationItem),{key:index,tag:"component",attrs:{"item":navigationItem}})}),_c('v-divider',{staticClass:"mx-1",attrs:{"vertical":""}}),_c('NavigationAuthButtons')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }